module.exports = __webpack_public_path__ + "img/checked-white.5fc7a7f1.svg";